module.exports = __webpack_public_path__ + "img/symbol_7.4945b5ad.png";